module.exports = __webpack_public_path__ + "img/theme_light_round.7ce868.svg";